/**
 * Determines whether the top static cross-sell banner should be relocated
 * to the dynamic banner position (position 4) instead of rendering at the top.
 * Returns true when on desktop and no dynamic flight banner is currently present.
 *
 * @param {Object} params
 * @param {boolean} params.isDesktop
 * @param {Object} params.listingsPropsObject
 * @returns {boolean}
 */
export const getShouldRelocateTopStaticXsell = ({ isDesktop, listingsPropsObject }) => {
  const dynamicBannerShowsUp = !!listingsPropsObject?.recommendedFlightBannerListing
  return isDesktop && !dynamicBannerShowsUp
}

/**
 * Returns true when the top static cross-sell banner should render at the top of the page.
 * False on the return tab, when there has been an error, when the banner should be relocated
 * to position 4, or when the PKG_DESKTOP_STATIC_BANNER_POSITION SETI is in variant (which
 * places it in the listings via insertDesktopStaticBannerPositionNodes instead).
 *
 * @param {Object} params
 * @param {number} params.activeTabId
 * @param {boolean} params.listingsHasErrored
 * @param {boolean} params.shouldRelocateTopStaticXsell
 * @param {boolean} params.isDesktopStaticBannerPositionVariant
 * @returns {boolean}
 */
export const getShowTopStaticXsell = ({
  activeTabId,
  listingsHasErrored,
  shouldRelocateTopStaticXsell,
  isDesktopStaticBannerPositionVariant,
}) =>
  activeTabId === 1 &&
  !listingsHasErrored &&
  !shouldRelocateTopStaticXsell &&
  !isDesktopStaticBannerPositionVariant
